import { get } from 'lodash';
import { api } from 'utils/hooks/useApi';
import { IGridConfiguration, IGridConfigurationForm } from './_types';

export const getAllGridConfiguration = (): Promise<IGridConfiguration[]> =>
  api()
    .post(`/portal-api/v1/grid-configuration/find`, {})
    .then((response) => get(response, 'data'))
    .catch((error) => false);

export const findGridConfiguration = (targetGrid: string): Promise<IGridConfiguration | null> =>
  api()
    .post(`/portal-api/v1/grid-configuration/find`, { bestForUser: true, targetGrid })
    .then((response) => get(response, 'data', [])[0] || null)
    .catch((error) => false);

export const getGridConfiguration = (id: string): Promise<IGridConfiguration> =>
  api()
    .get(`/portal-api/v1/grid-configuration/get`, { params: { id } })
    .then((response) => get(response, 'data'))
    .catch((error) => false);

export const editGridConfiguration = (
  gridConfiguration: IGridConfigurationForm,
): Promise<any | boolean> =>
  api().put(`/portal-api/v1/grid-configuration/update`, gridConfiguration);

export const createGridConfiguration = (
  gridConfiguration: IGridConfigurationForm,
): Promise<any | boolean> =>
  api().put(`/portal-api/v1/grid-configuration/create`, gridConfiguration);

export const removeConfiguration = (id: number): Promise<boolean> =>
  api()
    .delete(`/portal-api/v1/grid-configuration/delete`, { params: { id } })
    .then((response) => true)
    .catch((error) => false);
